import { IoClose } from "react-icons/io5";
import styled from "styled-components";

export const Backdrop = styled.div`
  position: fixed;
  z-index: 5000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  cursor: pointer;
`;

export const Content = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  color: var(--color-coal);
`;

export const ContentWrapper = styled.div`
  padding: 8px 24px 24px 24px;
`;


export const Title = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  font-size: 1rem;
  margin-bottom: 24px;
`;

export const OptionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  font-weight: 600;
`;

export const RadioCircle = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  transition: border-color 0.2s ease-in-out;
`;

export const Option = styled.li`
display: flex;
align-items: center;
padding: 12px 17px;
border: 2px solid rgb(204, 204, 204);
border-radius: 16px;
margin-bottom: 8px;
  &:hover {
    border-color: var(--color-orange);
    background-color: var(--color-orange-50);
    
    ${RadioCircle} {
      border-color: var(--color-orange);
    }
  }
`;

export const RadioCircleInner = styled.div`
  display: none;
  ${Option}:hover & {
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--color-orange);
  }
`;

export const Back = styled(IoClose)`
    color: var(--color-coal);
    width: 28px;
    height: 28px;
    cursor: pointer;
`;

export const CloseIcon = styled(IoClose)`
    color: #ffffff;
    width: 40px;
    height: 40px;
    cursor: pointer;
    float: right;
    margin: 24px 24px 0px 0;
`;

export const Close = styled.div`
    display: flex;
    justify-content: end;
    padding: 8px 8px 0px 0px;
`;